import React,{useContext} from 'react';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import Instructorsignupform from '../components/Instructorsignupform.js';
import Questions5 from '../components/QuestionsStep5';
import { Stepper,StepLabel,Step } from '@material-ui/core';
import { MultiStepContext } from '../StepContext5';
import sclm from '../images/sclm.png';
const Instructorsignup = () => {
    const {currentStep}= useContext(MultiStepContext);
  function showStep(step){
    switch(step){
      case 1:
        return <Instructorsignupform/>
      case 2:
        return <Questions5/>
      default:
        return <Instructorsignupform/>

    }
  }
  const backgroundStyle = {
    backgroundImage: `url(${sclm})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: 'auto', 
    padding: '70px 0 60px 0',
};
    return(
        <div>
            <Header />
            <div className="App" >
            <div style={backgroundStyle}>
              <div className="container">
                <div className="form-user">
                    <header className="App-header">
                        <div>
                          <h3>Instructor SIGNUP</h3>
                          <div className="stepsare">
                            <Stepper style={{witdth:'18%'}} activeStep={currentStep -1} >
                              
                                <Step>
                                    <StepLabel>Step 1</StepLabel>
                                </Step>
                                <Step>
                                    <StepLabel>Step 2</StepLabel>
                                </Step>
                              
                            </Stepper>
                          </div>  
                        </div>
                        {showStep(currentStep)}
                        

                      
                        
                    </header>
                  </div>  
                </div>    
            </div>
            </div>
         
            <Footer />
        </div>
    )
}

export default Instructorsignup;



